export default {
  name: 'ms-US English (Latin)',
  lang: ['en-US'],
  normal: [
    '\u624B \u7530 \u6C34 \u53E3 \u5EFF \u535C \u5C71 \u6208 \u4EBA \u5FC3',
    '\u65E5 \u5C38 \u6728 \u706B \u571F \u7AF9 \u5341 \u5927 \u4E2D',
    '\uFF3A \u96E3 \u91D1 \u5973 \u6708 \u5F13 \u4E00 {bksp}',
    '{numbers} {space} . -',
  ],
  numbers: [
    '1 2 3 4 5 6 7 8 9 0',
    '~ ! @ # $ % ^ & * ( ) _ +',
    '| , . / : \u0022 \u005c {bksp}',
    '{numbers} {space} . -',
  ],
};
